/* istanbul ignore file */
import { toBase64 } from '@change-corgi/core/base64';
import { getWindow } from '@change-corgi/core/window';

import { FONT_STYLE } from 'src/app/pages/starterDashboardV2/shared/constants';
import { createImage } from 'src/app/shared/utils/dom';

import { IMAGE_HEIGHT, IMAGE_WIDTH, TEXT_HEIGHT, TEXT_LINEHEIGHT, TEXT_PADDING } from './constants';

const TEXT_STYLES = `
  font-family: Noto Sans;
  font-weight: 900;
  background-color: #000000;
  color: white;
  font-size: ${TEXT_HEIGHT}px;
  line-height: ${TEXT_LINEHEIGHT}px;
  display: inline;
  text-align: center;
	text-transform: uppercase;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
  padding-inline: ${TEXT_PADDING}px;
`;

const getContent = (text: string) => `
  <style type="text/css">${FONT_STYLE}</style>
  <foreignObject width='${IMAGE_WIDTH}px' height='${IMAGE_HEIGHT}px'>
    <div style="display: flex; align-items: center; justify-content: center; height: 100%">
      <div style="text-align: center">
        <p style='${TEXT_STYLES}'>
          ${text}
        </p>
      </div>
    </div>
  </foreignObject>
`;

const svgToBase64 = (title: string) => {
	const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	svg.setAttribute('width', `${IMAGE_WIDTH}px`);
	svg.setAttribute('height', `${IMAGE_HEIGHT}px`);
	svg.innerHTML = getContent(title);

	// get svg data
	const xml = new XMLSerializer().serializeToString(svg);
	return `data:image/svg+xml;base64,${toBase64(xml)}`;
};

const imageToDataURL = async (src: string) =>
	// eslint-disable-next-line promise/avoid-new
	new Promise<string>((resolve) => {
		const image = createImage(IMAGE_WIDTH, IMAGE_HEIGHT);
		image.src = src;
		image.onload = () => {
			const pixelRatio = getWindow().devicePixelRatio;
			const canvas = document.createElement('canvas');
			canvas.setAttribute('style', `width: ${IMAGE_WIDTH}px; height: ${IMAGE_HEIGHT}px`);
			canvas.width = IMAGE_WIDTH * pixelRatio;
			canvas.height = IMAGE_HEIGHT * pixelRatio;
			const context = canvas.getContext('2d');
			if (!context) throw new Error('Canvas context not found');
			context.drawImage(image, 0, 0, IMAGE_WIDTH * pixelRatio, IMAGE_HEIGHT * pixelRatio);
			resolve(canvas.toDataURL('image/png'));
		};
	});

// #anything-can-be-an-api
export const getPetitionTitleImage = async (title: string) => {
	const imageSrc = svgToBase64(title);
	// double rendering the image because safari has a bug
	// that doesn't render the svg into the canvas the first time
	await imageToDataURL(imageSrc);
	return imageToDataURL(imageSrc);
};
